import $ from "jquery";


$(() => {
  $(".password span").on("click", handlePasswordInputClick);
});

const handlePasswordInputClick = (event) => {
  event.stopPropagation();
  const elem = $(event.target).parents('div.input-group.password');

  if ($(elem).find("input").attr("type") == "text") {
    $(elem).find("input").attr('type', 'password');
    $(elem).find("i").addClass("fa-eye-slash");
    $(elem).find("i").removeClass("fa-eye");
  } else if ($(elem).find("input").attr("type") == "password") {
    $(elem).find("input").attr('type', 'text');
    $(elem).find("i").removeClass("fa-eye-slash");
    $(elem).find("i").addClass("fa-eye");
  }
};